// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"ExpandingTextarea__srOnly--1l96L","hiddenInput":"ExpandingTextarea__hiddenInput--3kJ3x","root":"ExpandingTextarea__root--byZI4"};